/**
* @description
* # name controller --> educatorsListController
* # As Controller --> educatorsList
*/

export default class educatorsListController {
	constructor($scope,educatorsServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = educatorsServices.services
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.genderSelect = null
		this.$scope.code = null
		this.esValido = 0
		

		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.getEducators(params)
		this.getGenders()
	}
	
	getEducators(params){
		this.services.getEducators(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.educators = []
				this.educatorsList = dataReturn.results;
				for (let i in this.educatorsList){
					this.educators.push({
						title: this.educatorsList[i].ds_name + ' ' + this.educatorsList[i].ds_last_name,
						name: this.educatorsList[i].ds_name,
						lastName: this.educatorsList[i].ds_last_name,
						id_code: this.educatorsList[i].id_code,
						cod: this.educatorsList[i].ds_code,
						rut: this.educatorsList[i].ds_rut,
						badges: [
							{
								label: ( (this.educatorsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.educatorsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getGenders(){
		this.genders = [
			{
				id_code: 1,
				ds_name: 'femenino'
			},
			{
				id_code: 2,
				ds_name: 'masculino'
			}
		]
    }

	onClick(item){
		this.educatorId=item.id_code;
		this.code = item.cod;
		this.educatorName=item.name;
		this.lastName=item.lastName;
		this.getDetailsFunction({educator_id:this.educatorId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.services.getEducatorDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.educator = dataReturn.results
				this.$scope.genderSelect = this.educator.id_gender
				this.lastName = this.educator.ds_last_name
				this.rut = this.educator.ds_rut
				this.email = this.educator.ds_mail
				this.nameAttorney = this.educator.ds_name_attorney
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({educator_id : this.educatorId});
		
	}

	saveEdit(){
		if(this.educatorName === null || this.educatorName === '') {
			this.ngNotify.set('Indique nombre','warn')
			return
		}
		
		const params = {
			educator_id: this.educatorId,
			name: this.educatorName,
			ds_last_name: this.lastName,
			ds_rut: this.rut,
			ds_name_attorney: this.nameAttorney,
			gender_id: this.$scope.genderSelect,
			ds_mail: this.email,
			concept_id: this.conceptId,
			user_id: this.user_id
		}

		this.services.updateEducators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Docente','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de Docente se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de Docente ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	validarRut(rut) {
		if(rut === undefined || rut.length < 9 || !rut.includes('-')) { 
			this.ngNotify.set('Ingrese Rut','warn')
			return
		}
		rut = rut.toUpperCase()
		rut = rut.trim().split('-')

		const rutString = this.validarString(rut[0])
		const dvr = this.validarString(rut[1])
		let largo = rutString.length;
		let factor = 2;
		let contador = 0;
		let caracter = 0;
		let suma = 0;
		let cdv = '123456789K0';

		while (largo !== 0) {
			caracter = parseInt(rutString.charAt(largo - 1), 10);
			suma = suma + (caracter * factor);
			largo = largo - 1;
			factor = factor + 1;
			if (factor === 8) {
				factor = 2;
			}
		}

		let dv = 11 - (suma % 11)
		this.esValido = (cdv.charAt(dv - 1) === dvr) ? 1 : 0

		if(this.esValido) {
			this.ngNotify.set('Rut válido','success')
		} else {
			this.ngNotify.set('Rut inválido','warn')
		}

		return
	}

	validarString(cadena) {
		let resultado = cadena.trim()
		resultado = resultado.replace(/[^a-zA-Z0-9]/g, '')
	  
		return resultado;
	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
educatorsListController.$inject=['$scope', 'educatorsServices', 'ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/educators/list/educatorsListController.js